import React, { useRef, useState } from 'react';
import { IInlineEditableProps } from '../../../interfaces/interfaces';
import randomId from '../../../utils/randomId';

function InlineEditable(props: IInlineEditableProps): JSX.Element {
  const {
    children,
    isEditing,
    onChange,
    onBlur,
    value,
    placeholder,
    errorMessage,
    hideWhenEmpty,
    inputType,
    hasError,
  } = props;
  const [updatedValue, updateValue] = useState(value);
  const inputRef = useRef<HTMLInputElement>(null);

  const handleChange = () => {
    updateValue(inputRef.current?.value || '');
    onChange(inputRef.current?.value || '');
  };
  const handleBlur = () => {
    if (onBlur) {
      onBlur(inputRef.current?.value || '');
    }
  };
  const id = randomId();

  if (isEditing) {
    return (
      <div className="form-block">
        <div className={`form__element form__element--input ${hasError ? 'error' : ''}`}>
          <label className="label-top" htmlFor={id}>
            {placeholder}
          </label>
          <div className="focus-input">
            <input
              id={id}
              type={inputType || 'text'}
              className="inline-editable"
              value={updatedValue}
              placeholder={placeholder}
              onChange={handleChange}
              onBlur={handleBlur}
              required={updatedValue !== ''}
              ref={inputRef}
              pattern={inputType === 'tel' ? '^[0-9-+\\s()]*$' : undefined}
            />
          </div>
          <p className="error-message">{errorMessage}</p>
        </div>
      </div>
    );
  }
  if (hideWhenEmpty && updatedValue === '') {
    return <></>;
  }
  return <>{children}</>;
}

export default InlineEditable;
